export function ShimmerBlock({ className }: { className: string }) {
	return (
		<div className={`relative overflow-hidden bg-muted/50 ${className}`} aria-hidden="true">
			<div className="absolute inset-0 animate-pulse bg-gradient-to-r from-transparent via-foreground/10 to-transparent" />
		</div>
	);
}

export function PanelShimmer({ rows = 4, compact = false }: { rows?: number; compact?: boolean }) {
	return (
		<div className={compact ? "space-y-2" : "space-y-3"}>
			{Array.from({ length: rows }).map((_, index) => (
				<div key={index} className="overflow-hidden rounded-md border border-border bg-muted/20 p-2">
					<div className="flex items-center gap-2">
						<ShimmerBlock className="h-5 w-14 rounded-full" />
						<div className="min-w-0 flex-1 space-y-1.5">
							<ShimmerBlock className="h-3 w-2/3 rounded" />
							<ShimmerBlock className="h-2.5 w-1/3 rounded" />
						</div>
						<ShimmerBlock className="h-6 w-16 rounded-md" />
					</div>
					{!compact && (
						<div className="mt-2 grid grid-cols-3 gap-2">
							<ShimmerBlock className="h-2 rounded" />
							<ShimmerBlock className="h-2 rounded" />
							<ShimmerBlock className="h-2 rounded" />
						</div>
					)}
				</div>
			))}
		</div>
	);
}
